import { render } from "./cell_month.vue?vue&type=template&id=a31c7e3e"
import script from "./cell_month.vue?vue&type=script&lang=ts"
export * from "./cell_month.vue?vue&type=script&lang=ts"
script.render = render

export default script